<span>{{text}}</span>
<mat-icon class="close" (click)="removeElement()" *ngIf="hasRightToModifyTag">{{'close'}}</mat-icon>